var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('UserInfo',{attrs:{"user":_vm.currentUser,"allowMethodCreation":true,"showEditLink":true}}),_c('CardsListUser',{attrs:{"title":'Методы',"userId":_vm.currentUser.id,"showFraza":false}}),_c('CardsList',{attrs:{"title":'Выбранные методы',"cards":_vm.currentUser.favorite_cards}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }